import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import BackIcon from '@mui/icons-material/ArrowBackIos';
import { Button } from '@mui/material';
import classNames from 'classnames';
import { useLocation } from 'wouter';

import OdometerDetail from '@/components/odometer-detail/OdometerDetail';
import { Medium } from '@/constants/mediums';
import { ROUTE_PATHS } from '@/constants/routes';

import styles from './detail.module.css';

type ReadingsDetailPageProps = {
  medium: Medium;
};

const ReadingsDetailPage: FC<ReadingsDetailPageProps> = ({medium}) => {
  const { t } = useTranslation();
  const [, setLocation] = useLocation();

  const locations = {
    [Medium.electricity]: ROUTE_PATHS.READINGS,
    [Medium.water]: ROUTE_PATHS.WATER_READINGS,
    [Medium.gas]: ROUTE_PATHS.GAS_READINGS,
    [Medium.heat]: ROUTE_PATHS.HEAT_READINGS,
    [Medium.waste]: ROUTE_PATHS.WASTE_READINGS,
  }

  const detailLocations = {
    [Medium.electricity]: ROUTE_PATHS.READING_DETAIL,
    [Medium.water]: ROUTE_PATHS.WATER_READING_DETAIL,
    [Medium.gas]: ROUTE_PATHS.GAS_READING_DETAIL,
    [Medium.heat]: ROUTE_PATHS.HEAT_READING_DETAIL,
    [Medium.waste]: ROUTE_PATHS.WASTE_READING_DETAIL,
  }

  return (
    <div className={classNames(styles.page)}>
      <div>
        <Button
          variant="outlined"
          type="button"
          size="large"
          data-cy-button="back"
          startIcon={<BackIcon />}
          onClick={() =>
            setLocation(
              `${ROUTE_PATHS.ENERGY}/${medium}${locations[medium]}`
            )
          }
        >
          {t('common.back')}
        </Button>
      </div>
      <OdometerDetail route={detailLocations[medium]} />
    </div>
  );
};

export default ReadingsDetailPage;
